import React, { Component } from "react";
import { Row, Col, Table, Tooltip, OverlayTrigger, Alert } from "react-bootstrap";
import moment from "moment";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import FormDetailsModal from "./FormDetailsModal.jsx";
import { fetchPendingFormsRequest, handleFormApprovalRequest } from "../../api/form";
import { getFullName } from "helpers/functions/employee";
import { getFormattedFormType } from 'helpers/functions/form';

class FormApprovalList extends Component {

  state = {
    data: null,
    error: null,
    showFormModal: false,
    selectedFormId: null
  };

  componentDidMount() {
    if (!this.state.data)
      this.fetchForms()
  }

  fetchForms(){
    fetchPendingFormsRequest(
      result => this.setState({data: result, error: null}),
      error => this.setState({error: error})
    )
  }

  approveForm = (id) => {
    const data = {
      status: "Approved"
    }

    handleFormApprovalRequest(id, data,
      result => {
        this.fetchForms()
        this.setState({
          showFormModal: false,
          selectedFormId: null
        })
      },
      error => this.setState({error: error})
    );
  }

  rejectForm = (id) => {
    const data = {
      status: "Rejected"
    }

    handleFormApprovalRequest(id, data,
      result => {
        this.fetchForms()
        this.setState({
          showFormModal: false,
          selectedFormId: null
        })
      },
      error => this.setState({error: error})
    );
  }

  openFormModal = (id) => {
    this.setState({
      error: null,
      showFormModal: true,
      selectedFormId: id
    })
  }

  closeFormModal = () => {
    this.setState({
      showFormModal: false,
      selectedFormId: null
    })
  }

  render() {
    const { data, error } = this.state;
    const view = <Tooltip id="view_tooltip">Details</Tooltip>;
    const edit = <Tooltip id="edit_tooltip">Approve</Tooltip>;
    const remove = <Tooltip id="remove_tooltip">Reject</Tooltip>;

    return (
      <div className="content">
          {error && <Alert bsStyle="danger" role="alert">{error.message || "Could not update the request."}</Alert>}
          <Row>
            <Col md={12}>
              <Card
                title="Forms to Approve"
                category="List of Forms that require approval"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th>Date Created</th>
                          <th>Employee</th>
                          <th>Form Type</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {data && data.length > 0 
                          ? data.map(instance => {
                            return (
                              <tr key={instance._id}>
                                <td>{moment(instance.createdAt).format("DD/MM/YYYY HH:MM") || "N/A"}</td>
                                <td>{instance.employee ? getFullName(instance.employee) : "N/A"}</td>
                                <td>{getFormattedFormType(instance.formType, instance.applicationType) || "N/A"}</td>
                                <td className="td-actions text-right">
                                  <OverlayTrigger placement="top" overlay={view}>
                                    <CustomButtom 
                                      bsStyle="success" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.openFormModal(instance._id)}
                                    >
                                      <i className="fa fa-eye" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={edit}>
                                    <CustomButtom 
                                      bsStyle="info" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.approveForm(instance._id)}
                                    >
                                      <i className="fa fa-check" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={remove}>
                                    <CustomButtom 
                                      bsStyle="danger" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.rejectForm(instance._id)}
                                    >
                                      <i className="fa fa-times" />
                                    </CustomButtom>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            )}
                          )
                          : (
                            <tr>
                              <td colSpan='6'>There are no forms that need approval.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  </div>
                }
              />
            </Col>
          </Row>
          <FormDetailsModal
            showModal={this.state.showFormModal}
            closeModal={this.closeFormModal}
            id={this.state.selectedFormId}
            error={error && (error.message || "Could not update the request.")}
            approveForm={this.approveForm}
            rejectForm={this.rejectForm}
          />
      </div>
    );
  }
}

export default FormApprovalList;
